// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"768943ee","79":"4212bf30"}[chunkId] + ".chunk.css";
};